const AppSettingsDefaults = {

  ui: {
    REQUESTER_SIDEBAR_WIDTH: 300,
    REQUESTER_BROWSER_WIDTH: 365,
    REQUESTER_TAB_REQUEST_PANE_WIDTH: 495,
    REQUESTER_TAB_RESPONSE_WIDTH: 495,
    REQUESTER_TAB_REQUEST_PANE_MAX_FALLBACK_WIDTH: 700,
    REQUESTER_TAB_REQUEST_ACTIONS_WIDTH: 105, // width of actions ("cookies" + "code")

    // when width goes lower than this, request tabs ("params", "headers",
    // etc.) collapse to take smaller space
    REQUESTER_TAB_REQUEST_TABS_COLLAPSE_THRESHOLD: 800,

    // when width goes lower than this, request body selector ("raw",
    // "form-data", etc.) collapse into a dropdown
    REQUESTER_TAB_REQUEST_BODY_TYPE_SELECTOR_COLLAPSE_THRESHOLD: 800,

    // configuration values for request editor tab panes
    REQUESTER_URL_PANE_HEIGHT: 57, // 56px + 1px for border
    REQUESTER_REQUEST_EDITOR_PANE_DEFAULT_HEIGHT: 200,
    REQUESTER_REQUEST_EDITOR_PANE_DEFAULT_WIDTH: 400,
    REQUESTER_REQUEST_EDITOR_PANE_COLLAPSED_HEIGHT: 33,
    REQUESTER_REQUEST_EDITOR_PANE_COLLAPSED_WIDTH: 33,
    REQUESTER_REQUEST_EDITOR_PANE_UNCOLLAPSED_HEIGHT: 200,
    REQUESTER_REQUEST_EDITOR_PANE_UNCOLLAPSED_WIDTH: 400,
    REQUESTER_REQUEST_EDITOR_PANE_MIN_HEIGHT: 100,
    REQUESTER_REQUEST_EDITOR_PANE_MIN_WIDTH: 300,

    // configurations for websocket tab
    WEBSOCKET_REQUEST_URL_PANE_DEFAULT_HEIGHT: 130,
    WEBSOCKET_REQUEST_URL_PANE_MIN_HEIGHT: 150,
    WEBSOCKET_REQUEST_URL_PANE_COLLAPSED_HEIGHT: 80,
    WEBSOCKET_REQUEST_URL_PANE_UNCOLLAPSED_HEIGHT: 250,
    WEBSOCKET_REQUEST_COMPOSE_PANE_DEFAULT_HEIGHT: 250,
    WEBSOCKET_REQUEST_COMPOSE_PANE_MIN_HEIGHT: 100,
    WEBSOCKET_REQUEST_COMPOSE_PANE_COLLAPSED_HEIGHT: 32,
    WEBSOCKET_REQUEST_COMPOSE_PANE_UNCOLLAPSED_HEIGHT: 250,
    WEBSOCKET_REQUEST_MESSAGES_PANE_DEFAULT_HEIGHT: 600,
    WEBSOCKET_REQUEST_MESSAGES_PANE_MIN_HEIGHT: 200,
    WEBSOCKET_REQUEST_MESSAGES_PANE_COLLAPSED_HEIGHT: 32,
    WEBSOCKET_REQUEST_MESSAGES_PANE_UNCOLLAPSED_HEIGHT: 600,
    SOCKETIO_WEBSOCKET_REQUEST_SUBSCRIPTION_PANE_DEFAULT_WIDTH: 250,
    SOCKETIO_WEBSOCKET_REQUEST_SUBSCRIPTION_PANE_MAX_WIDTH: 300,
    SOCKETIO_WEBSOCKET_REQUEST_SUBSCRIPTION_PANE_MIN_WIDTH: 200,
    SOCKETIO_WEBSOCKET_REQUEST_SUBSCRIPTION_PANE_COLLAPSED_WIDTH: 32,
    SOCKETIO_WEBSOCKET_REQUEST_SUBSCRIPTION_PANE_UNCOLLAPSED_WIDTH: 250,
    SOCKETIO_WEBSOCKET_REQUEST_MESSAGES_PANE_DEFAULT_WIDTH: 1000,

    // when width goes lower than this, response meta ("code", "time", etc.)
    // collapse to take smaller space
    REQUESTER_TAB_RESPONSE_META_COLLAPSE_THRESHOLD: 800,
    RESPONSE_FONT_SIZE: 12,
    ZOOM: 0,
    SCALE: 0,
    DEFAULT_DATA_EDITOR_COLUMNS: ['key', 'value', 'description'],
    DEFAULT_SESSION_DATA_EDITOR_COLUMNS: ['key', 'value', 'sessionValue'],

    WORKBENCH_MIN_WIDTH: 400,
    CONTEXT_BAR_MIN_WIDTH: 350,
    SIDEBAR_MIN_WIDTH: 380,
    REQUESTER_MIN_WIDTH: 1130,

    // Comment Pane
    COMMENT_PANE_DEFAULT_WIDTH: 400,
    COMMENT_PANE_COLLAPSED_WIDTH: 33,
    COMMENT_PANE_UNCOLLAPSED_WIDTH: 400,
    COMMENT_PANE_MIN_WIDTH: 380,
    COMMENT_PANE_MAX_WIDTH: 500,

    // For Context Bar in Collection, Globals, Environment, Request and Example tab
    CONTEXT_BAR_WIDTH_CONFIG: {
      collapsedByDefault: true,
      default: 440,
      collapsed: 40,
      uncollapsed: 440,
      min: 300,
      max: 500
    },

    // Sidebar
    DEFAULT_ACTIVE_SIDEBAR: 'collection',

    // For collection and folder tab header pane
    ENTITY_TAB_HEADER_PANE_DEFAULT_HEIGHT: 48
  },
  general: {
    XHR_TIMEOUT: 0,
    MAX_RESPONSE_SIZE: 50 * 1024 * 1024 // 50 MB
  },
  autoDownload: {
    MINOR: 1,
    ALL: 2
  }

};

export default AppSettingsDefaults;
